import { downloadFile } from '../../../shared/api/download';

export function downloadReport(
    reportId: string,
    projectName: string,
    withLogistics: boolean,
): Promise<void> {
    const name = projectName.trim();
    const title = name
        ? `Отчёт по работе сервиса предиктивной аналитики «${name}»`
        : 'Отчёт по работе сервиса предиктивной аналитики';

    const suffix = withLogistics ? ' с логистикой' : '';

    return downloadFile(
        `/api/reports/${reportId}/export?upload_logistics_to_report=${withLogistics}`,
        `${title}${suffix}.xlsx`,
    );
}